var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vuetable-pagination-info', _vm.css.infoClass],domProps:{"innerHTML":_vm._s(_vm.paginationInfo)}})}
var staticRenderFns = []

export { render, staticRenderFns }